import { SvgIcon } from '@mui/material';
import React from 'react';

/**
 * Logo Maisons du Monde (marketplace) – logo officiel avec fond noir et texte blanc.
 * Source : maisons du monde.svg (couleurs officielles #393536 fond, #ffffff texte).
 */
const MaisonsDuMondeIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 41.229004 16.46298" {...props}>
      <g transform="translate(-48.177164,-119.43518)">
        <g>
          <path
            fill="#393536"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeWidth="0.34712622"
            d="M 48.177164,135.89816 H 89.406169 V 119.43518 H 48.177164 Z"
          />
          <path
            fill="#ffffff"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeWidth="0.34712622"
            d="m 50.85139,129.43787 h 35.9063 v -0.37784 h -35.9063 z"
          />
          <g transform="matrix(0.3527072,0,0,-0.34163352,55.712049,122.34487)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 h 0.044 l 4.011,-15.313 -3.768,-0.53 -1.301,7.282 h -0.043 l -3.965,-7.282 h -0.045 l -3.614,7.259 h -0.042 l -1.3,-7.259 -3.833,0.53 L -9.714,0 h 0.042 l 4.759,-9.268"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,60.238339,122.34487)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 -8.054,-15.073 3.632,-0.77 1.519,3.234 H 2.84 l 1.539,-3.234 3.809,0.77 L 0.045,0 Z m 0,-6.102 2.003,-3.715 h -4.005"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,64.923703,122.34487)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 v -15.331 l -3.745,-0.351 v 15.329"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,68.915997,123.82858)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 c -0.856,0.752 -1.515,1.151 -2.682,1.151 -0.659,0 -1.651,-0.399 -1.651,-1.195 0,-2.408 6.745,-0.839 6.745,-6.409 0,-3.396 -2.631,-5.047 -5.774,-5.047 -1.866,0 -3.8,0.551 -5.227,1.782 l 2.239,2.866 c 0.704,-0.818 1.712,-1.216 2.833,-1.216 0.771,0 1.98,0.376 1.98,1.349 0,2.364 -6.743,0.95 -6.743,6.387 0,3.001 2.765,4.674 5.491,4.674 1.736,0 3.491,-0.637 4.829,-1.74"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,73.349525,122.34487)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 c -4.402,0 -8.058,-3.499 -8.058,-7.921 0,-4.423 3.656,-7.922 8.058,-7.922 4.4,0 8.057,3.499 8.057,7.922 C 8.057,-3.499 4.4,0 0,0 m 0,-3.43 c 2.377,0 4.313,-2.169 4.313,-4.491 0,-2.322 -1.936,-4.49 -4.313,-4.49 -2.377,0 -4.315,2.168 -4.315,4.49 0,2.322 1.938,4.491 4.315,4.491"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,81.891036,127.75737)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M 0,0 -9.851,8.619 V 0.512 L -13.597,0.16 v 15.683 h 0.045 l 9.853,-8.472 v 8.119 l 3.743,0.353 V 0"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,85.88615,123.82858)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 c -0.855,0.752 -1.515,1.151 -2.682,1.151 -0.657,0 -1.648,-0.399 -1.648,-1.195 0,-2.408 6.744,-0.839 6.744,-6.409 0,-3.396 -2.633,-5.047 -5.777,-5.047 -1.866,0 -3.799,0.551 -5.226,1.782 l 2.239,2.866 c 0.702,-0.818 1.712,-1.216 2.835,-1.216 0.769,0 1.979,0.376 1.979,1.349 0,2.364 -6.743,0.95 -6.743,6.387 0,3.001 2.764,4.674 5.489,4.674 1.738,0 3.49,-0.637 4.83,-1.74"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,50.827406,132.92662)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 h 2.655 c 2.177,0 3.928,1.661 3.928,3.829 0,2.17 -1.751,3.831 -3.928,3.831 H 0 Z m 1.895,6.044 h 0.592 c 1.229,0 2.202,-1.04 2.202,-2.215 0,-1.173 -0.973,-2.214 -2.202,-2.214 H 1.895"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,57.9856,132.02095)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 c 0,-1.785 -1.394,-2.832 -3.313,-2.832 -1.785,0 -3.032,0.834 -3.032,2.698 V 5.011 L -4.449,5.19 V 0.403 c 0,-0.816 0.232,-1.498 1.181,-1.498 1.227,0 1.372,0.862 1.372,1.912 V 5.011 L 0,5.19"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,66.298909,130.24788)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 h 0.024 l 2.031,-7.752 -1.908,-0.27 -0.659,3.69 h -0.023 l -2.01,-3.69 h -0.022 l -1.832,3.676 H -4.422 L -5.079,-8.022 -7.023,-7.752 -4.925,0 h 0.022 l 2.413,-4.692"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,70.79134,130.24788)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 c -2.239,0 -4.091,-1.77 -4.091,-4.012 0,-2.24 1.852,-4.01 4.091,-4.01 2.239,0 4.09,1.77 4.09,4.01 C 4.09,-1.77 2.239,0 0,0 m 0,-1.737 c 1.209,0 2.194,-1.097 2.194,-2.275 0,-1.174 -0.985,-2.273 -2.194,-2.273 -1.209,0 -2.194,1.099 -2.194,2.273 0,1.178 0.985,2.275 2.194,2.275"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,77.267043,132.98846)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M 0,0 -5.026,4.37 V 0.259 L -6.921,0.08 v 7.942 h 0.022 L -1.874,3.731 V 7.843 L 0.021,8.022 V 0"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,79.991003,132.92662)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="m 0,0 h 2.653 c 2.18,0 3.931,1.661 3.931,3.829 0,2.17 -1.751,3.831 -3.931,3.831 H 0 Z m 1.894,6.044 h 0.594 c 1.225,0 2.201,-1.04 2.201,-2.215 0,-1.173 -0.976,-2.214 -2.201,-2.214 H 1.894"
            />
          </g>
          <g transform="matrix(0.3527072,0,0,-0.34163352,84.925024,132.92662)">
            <path
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M 0,0 V 7.66 H 4.331 L 4.666,6.044 H 1.895 V 4.709 H 3.873 V 3.091 H 1.895 V 1.615 H 4.9 L 4.431,0"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default MaisonsDuMondeIcon;